import { Injectable } from '@angular/core';
import {
  FileOpener,
  FileOpenerOptions,
} from '@capacitor-community/file-opener';
import { Directory, Encoding, Filesystem } from '@capacitor/filesystem';
import write_blob from 'capacitor-blob-writer';

@Injectable({
  providedIn: 'root',
})
export class MobileFileService {
  constructor() {
    this.ensurePermissions();
  }
  // Ensure necessary permissions for accessing external storage
  async ensurePermissions() {
    try {
      const { publicStorage } = await Filesystem.checkPermissions();

      if (publicStorage !== 'granted') {
        await Filesystem.requestPermissions();
      }
    } catch (e) {
      console.error('Failed to request permissions:', e);
    }
  }

  writeFileOnDevice(
    fileName: string,
    content: any,
    openFileAfterSave: boolean = false,
  ): Promise<any> {
    this.ensurePermissions();
    if (content instanceof Blob) {
      return write_blob({
        path: fileName,
        blob: content,
        directory: Directory.Documents,
        fast_mode: true,
        recursive: true,
      }).then((filePath) => {
        if (openFileAfterSave) {
          this.openFile(filePath, fileName);
        }
        return Promise.resolve({ nativeURL: fileName });
      });
    } else {
      return Filesystem.writeFile({
        path: fileName,
        data: content,
        directory: Directory.Documents,
        encoding: Encoding.UTF8,
      }).then((filePath) => {
        if (openFileAfterSave) {
          this.openFile(filePath, fileName);
        }
        return Promise.resolve({ nativeURL: fileName });
      });
    }
  }

  private openFile(FilePath, fileName) {
    try {
      const fileOpenerOptions: FileOpenerOptions = {
        filePath: FilePath,
        contentType: this.getMIMETypeFromFile(fileName),
        openWithDefault: true,
      };
      FileOpener.open(fileOpenerOptions);
    } catch (e) {
      console.log('Error opening file', e);
    }
  }

  private getMIMETypeFromFile(fileName: string) {
    let extension = fileName.split('.')[fileName.split('.').length - 1];
    let MIMETypes = {
      txt: 'text/plain',
      docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      doc: 'application/msword',
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      bmp: 'image/bmp',
      png: 'image/png',
      xls: 'application/vnd.ms-excel',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      rtf: 'application/rtf',
      ppt: 'application/vnd.ms-powerpoint',
      pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    };

    return MIMETypes[extension];
  }
}
